export default {
  // Page titles
  campaigns: {
    title: 'Campañas SMS'
  },
  automation: {
    title: 'Automatización SMS',
    ndc: 'Sin Depósito Después del Registro',
    inactive: 'Usuarios Inactivos',
    churn: 'Usuarios Perdidos',
    welcome: 'SMS de Bienvenida',
    restorage: 'Redepósito Después del Primer Depósito',
    birthday: 'Recordatorio de Cumpleaños',
    vip: 'Usuarios VIP',
    allMembers: 'Todos los Miembros'
  },
  vip: {
    title: 'Usuarios SMS VIP'
  },

  // Task types
  type: {
    bulk: 'Envío Masivo',
    ndc: 'Sin Depósito',
    inactive: 'Inactivo',
    churn: 'Perdido',
    vip: 'Tareas VIP',
    welcome: 'SMS de Bienvenida',
    restorage: 'Redepósito Después del Primer Depósito',
    birthday: 'Recordatorio de Cumpleaños',
    unknown: 'Desconocido'
  },

  // Form related
  form: {
    taskName: 'Nombre de Tarea',
    taskNamePlaceholder: 'Ingrese el nombre de la tarea',
    country: 'Región',
    countryPlaceholder: 'Seleccione la región',
    vip: 'Nivel VIP',
    vipPlaceholder: 'Seleccione el nivel VIP',
    status: 'Estado',
    statusPlaceholder: 'Seleccione el estado',
    template: 'Plantilla SMS',
    templatePlaceholder: 'Seleccione la plantilla SMS',
    selectCategoryFirst: 'Seleccione primero la categoría de plantilla',
    agent: 'Agente',
    agentPlaceholder: 'Ingrese el nombre del agente',
    haveLogin: 'Ha Iniciado Sesión',
    haveBet: 'Ha Apostado',
    inOut: 'Tipo de Usuario',
    inOutPlaceholder: 'Seleccione el tipo de usuario',
    sendTime: 'Tiempo de Envío',
    sendTimePlaceholder: 'Ingrese el valor',
    depositOrder: 'Secuencia de Depósito',
    depositOrderPlaceholder: 'Ingrese la cantidad específica, p. ej. 5',
    dailyPlaceholder: 'Ingrese los días',
    weeklyPlaceholder: 'Ingrese 1-7 (1=Lunes, 7=Domingo)',
    monthlyPlaceholder: 'Ingrese 1-31 (día del mes)',
    timeUnit: 'Unidad de Tiempo',
    templateContentPlaceholder: 'Seleccione primero la plantilla',
    templateContent: 'Contenido de la Plantilla (Solo lectura)',
    importUsers: 'Importar Usuarios',
    importPhones: 'Importar Números de Teléfono',
    bulkSend: 'Envío Masivo',
    selectFile: 'Seleccionar Archivo (CSV; coma/espacio/nueva línea; deduplicación automática)',
    chooseFile: 'Elegir Archivo',
    uploaded: 'Cargado',
    notImported: 'No Importado',
    importUsersPlaceholder: 'Importar nombres de usuario (CSV; coma/espacio/nueva línea; deduplicación automática)',
    importPhonesPlaceholder: 'Importar Números de Teléfono (CSV; coma/espacio/nueva línea; deduplicación automática)'
  },

  // Upload related
  upload: {
    invalidFileType: 'Cargue archivos de Excel relacionados (.xlsx, .xls, .xlsm, .xlsb, .csv, .txt)',
    success: 'Archivo de Excel cargado exitosamente',
    failed: 'Error al cargar archivo de Excel',
    error: 'Error al cargar archivo de Excel: {{error}}',
    pleaseUploadFirst: 'Cargue primero el archivo de Excel'
  },

  // User types
  inOut: {
    internal: 'Usuario Interno',
    external: 'Usuario Externo'
  },

  // Time units
  timeUnit: {
    minutes: 'Minutos',
    hours: 'Horas',
    days: 'Días',
    weeks: 'Semanas',
    months: 'Meses'
  },

  // Table related
  table: {
    taskName: 'Nombre de Tarea',
    template: 'Plantilla',
    country: 'País',
    vipLevel: 'Nivel VIP',
    sendTiming: 'Tiempo de Envío',
    status: 'Estado',
    actions: 'Acciones',
    createUser: 'Creador',
    createTime: 'Creado en',
    operator: 'Operador',
    depositOrder: 'Secuencia de Depósito',
    depositOrderValue: 'Intento de depósito {{times}}'
  },

  // Condition labels
  condition: {
    haveLogin: 'Ha Iniciado Sesión',
    haveBet: 'Ha Apostado'
  },

  // Status related
  status: {
    enabled: 'Habilitado',
    disabled: 'Deshabilitado'
  },

  // Button related
  button: {
    create: 'Crear Tarea',
    execute: 'Ejecutar Ahora',
    sendNow: 'Enviar Ahora',
    uploadFile: 'Cargar Archivo',
    createInternalCampaign: 'Crear Campaña para Usuarios Internos',
    createExternalCampaign: 'Crear Campaña para Usuarios Externos',
    importLog: 'Registro de Importación'
  },

  // Modal related
  modal: {
    createTitle: 'Crear Tarea SMS',
    editTitle: 'Editar Tarea SMS',
    viewTitle: 'Ver Tarea SMS',
    importLogTitle: 'Registro de Importación de Lista',
    close: 'Cerrar'
  },

  // Re-deposit task hint
  restorage: {
    hint: 'Usuarios elegibles: aquellos que no realicen otro depósito dentro de 23 horas después de su Nth depósito recibirán este SMS.'
  },

  // Advanced filter
  advancedFilter: {
    title: 'Filtro Avanzado',
    excludeUser: 'Excluir Usuarios del Sitio Oficial',
    excludeAgent: 'Excluir Usuarios del Agente',
    excludeAgentWithHint: 'Excluir Usuarios del Agente (Búsqueda, Múltiple)',
    selectAgents: 'Seleccionar Agentes a Excluir',
    selectAgentsPlaceholder: 'Seleccione agentes (búsqueda, múltiple)',
    off: 'Apagado',
    on: 'Encendido',
    excludeAllAgents: 'Excluir Todos los Agentes',
    excludeSomeAgents: 'Excluir Algunos Agentes',
    mobileValid: 'Usuarios con Número de Teléfono Verificado',
    // VIP task specific
    recentLoginPrefix: 'Enviar solo a usuarios que iniciaron sesión en los últimos',
    recentLoginSuffix: 'días',
    recentLoginFullText: 'Enviar solo a usuarios que iniciaron sesión en los últimos [] días',
    recentLoginTooltip: 'El sistema filtrará usuarios con registros de inicio de sesión en los últimos n días antes de enviar (dejar en blanco sin límite)',
    recentLoginDays: 'Usuarios que iniciaron sesión en {{days}} días'
  },

  // Validation related
  validation: {
    taskNameRequired: 'Ingrese el nombre de la tarea',
    countryRequired: 'Seleccione el país',
    templateRequired: 'Seleccione la plantilla SMS',
    sendTimeRequired: 'Ingrese la hora de envío',
    timeUnitRequired: 'Seleccione la unidad de tiempo',
    weeklyRangeError: 'La frecuencia semanal debe estar entre 1-7 (1=Lunes, 7=Domingo)',
    monthlyRangeError: 'La fecha mensual debe estar entre 1-31',
    agentRequired: 'Seleccione agentes a excluir',
    recentDayRequired: 'Ingrese el número de días',
    recentDayRange: 'Los días deben estar entre 1-365',
    excludeUserAndAllAgentsConflict: 'No puede seleccionar tanto "Excluir Usuarios del Sitio Oficial" como "Excluir Todos los Agentes" al mismo tiempo',
    excludeUserAndAllAgentsConflictSubmit: 'No puede seleccionar tanto "Excluir Usuarios del Sitio Oficial" como "Excluir Todos los Agentes" al mismo tiempo, modifique antes de enviar',
    depositOrderRequired: 'Ingrese la secuencia de depósito',
    depositOrderMin: 'La secuencia de depósito debe ser al menos 1',
    sendTimeMinutesMax: 'Los minutos no pueden exceder 4320',
    sendTimeHoursMax: 'Las horas no pueden exceder 72',
    sendTimeDaysMax: 'Los días no pueden exceder 30'
  },

  // Message related
  message: {
    queryFailed: 'Error en la consulta',
    createSuccess: 'Creado exitosamente',
    createFailed: 'Error en la creación',
    updateSuccess: 'Actualizado exitosamente',
    updateFailed: 'Error en la actualización',
    deleteSuccess: 'Eliminado exitosamente',
    deleteFailed: 'Error en la eliminación',
    statusUpdateSuccess: 'Estado actualizado exitosamente',
    statusUpdateFailed: 'Error al actualizar el estado',
    executeSuccess: 'Ejecutado exitosamente',
    executeFailed: 'Error en la ejecución'
  },

  // Confirm related
  confirm: {
    delete: '¿Está seguro de que desea eliminar esta tarea?',
    toggleStatus: '¿Está seguro de que desea cambiar el estado de esta tarea?',
    execute: '¿Está seguro de que desea ejecutar esta tarea inmediatamente?',
    send: '¿Está seguro de que desea enviar esta tarea inmediatamente?'
  },

  // Pagination related
  pagination: {
    total: 'Total {{total}} registros'
  },

  // Deposit user task note
  automationRestorageNote: 'Las tareas de usuarios con depósito se activan en el momento indicado después del primer depósito; asegúrese de que el contenido de la plantilla se ajuste al escenario de reactivación.',

  // Import log
  importLog: {
    "taskCode": "Código de la Tarea",
    "taskName": "Nombre de la Tarea",
    uploadFileStatus: {
      '80009001': 'Pendiente',
      '80009002': 'Completado'
    },
    header: {
      taskName: 'Tarea',
      importer: 'Importador',
      operator: 'Operador',
      latestImportTime: 'Última Hora de Importación',
      importFileName: 'Nombre del Archivo de Importación',
      importCompleteTime: 'Hora de Importación Completa',
      importStatus: 'Estado de Importación'
    },
    stats: {
      success: 'Éxito',
      failed: 'Fallido',
      total: 'Total'
    },
    failureDetails: {
      title: 'Detalles de Fallos',
      searchPlaceholder: 'Buscar nombre de usuario fallido',
      exportFailed: 'Exportación Fallida',
      memberAccount: 'Cuenta de Miembro',
      failureReason: 'Motivo del Fallo',
      failureTime: 'Hora del Fallo',
      rowNumber: 'Fila #',
      remarks: 'Observaciones',
      hint: 'Nota: Las cuentas de usuario fallidas se conservan solo por un mes',
      loading: 'Cargando...',
      noFailedRecords: 'Sin registros fallidos',
      noImportRecords: 'Sin registros de importación',
      exportNotImplemented: 'Exportación no implementada'
    }
  }
};
